'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function HeroSection() {
    const [isHydrated, setIsHydrated] = useState(false);

    useEffect(() => {
        setIsHydrated(true);
    }, []);

    if (!isHydrated) {
        return (
            <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-background via-surface to-background" />
            </section>
        );
    }

    return (
        <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-background via-surface to-background">
                <div className="absolute inset-0 opacity-30">
                    <div className="absolute top-20 left-10 w-72 h-72 bg-primary/20 rounded-full blur-3xl animate-pulse" />
                    <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-success/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }} />
                </div>
            </div>

            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
                <div className="inline-flex items-center space-x-2 glass glass-border px-4 py-2 rounded-full mb-8 animate-fade-in">
                    <Icon name="SparklesIcon" size={20} variant="solid" className="text-accent" />
                    <span className="text-sm font-medium text-text-secondary">Transforming Education Since 2024</span>
                </div>

                <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-6 animate-fade-in" style={{ animationDelay: '0.1s' }}>
                    <span className="gradient-text">Where Ancient Wisdom</span>
                    <br />
                    <span className="text-text-primary">Meets Modern Learning</span>
                </h1>

                <p className="text-xl text-text-secondary max-w-3xl mx-auto mb-12 leading-relaxed animate-fade-in" style={{ animationDelay: '0.2s' }}>
                    AstikLearn embodies the fusion of timeless educational principles with cutting-edge technology, creating a beacon of hope in the digital learning landscape. We're not just a platform—we're your confident, sophisticated mentor guiding you through the infinite possibilities of knowledge.
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in" style={{ animationDelay: '0.3s' }}>
                    <div className="glass glass-border px-8 py-4 rounded-lg">
                        <div className="text-3xl font-bold gradient-text mb-1">1000</div>
                        <div className="text-sm text-text-secondary">Active Learners</div>
                    </div>
                    <div className="glass glass-border px-8 py-4 rounded-lg">
                        <div className="text-3xl font-bold gradient-text mb-1">2</div>
                        <div className="text-sm text-text-secondary">Partner Institutions</div>
                    </div>
                    <div className="glass glass-border px-8 py-4 rounded-lg">
                        <div className="text-3xl font-bold gradient-text mb-1">88%</div>
                        <div className="text-sm text-text-secondary">Success Rate</div>
                    </div>
                </div>
            </div>

            <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent" />
        </section>
    );
}